import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    content: {
        position: "relative",
        height:'100%',
        flex:1,
        display:'flex',
        flexDirection:'column',
    },
    root:{
        height:'100%',
        flex:1,
    }
}